export const TRAVEL_JOURNEY_DIRECT = 'direct';
export const TRAVEL_ORIGIN_CUSTOMER = 'CUSTOMER_PORTAL';
const TRAVEL_PRODUCT_TITLE = 'Travel insurance';

export function isCustomerTravelEnabled() {
  const disabled = process.env.VUE_APP_CUSTOMER_TRAVEL_DISABLED;
  return disabled !== 'true' && disabled !== '1';
}

export function resolveTravelChannel(routeMeta) {
  return routeMeta?.travelChannel === 'customer' ? 'customer' : 'agent';
}

export function getTravelChannelConfig(routeMeta) {
  const channel = resolveTravelChannel(routeMeta);
  if (channel === 'customer') {
    return {
      channel: 'customer',
      defaultJourney: TRAVEL_JOURNEY_DIRECT,
      origin: TRAVEL_ORIGIN_CUSTOMER,
      routes: {
        products: 'CustomerProductSelect',
        planSelect: 'CustomerTravelPlanSelect',
        sale: 'CustomerTravelSale',
        finalization: 'CustomerTravelFinalization',
        dashboard: 'Dashboard',
      },
      labels: {
        planBreadcrumb: 'Buy cover / Travel',
        planTitle: TRAVEL_PRODUCT_TITLE,
        planSub: 'Select cover and dates — your premium updates live.',
        saleBreadcrumb: `${TRAVEL_PRODUCT_TITLE} / Complete purchase`,
        saleTitle: 'Traveller details & payment',
        contactSection: 'Your contact',
        contactHint: 'We send the policy certificate to this email after issuance.',
        declaration: 'I confirm the details are correct and agree to Pacis data protection policy.',
        newSale: 'Start over',
        newSaleSub: 'Unsaved details in this session will be removed.',
      },
      trackAnalytics: false,
      useAgentPayment: false,
      prefillContactFromProfile: true,
    };
  }
  return {
    channel: 'agent',
    defaultJourney: 'quote',
    origin: null,
    routes: {
      products: 'AgentProductSelect',
      planSelect: 'AgentTravelPlanSelect',
      sale: 'AgentTravelSale',
      finalization: 'AgentTravelFinalization',
      dashboard: 'AgentDashboard',
    },
    labels: {
      planBreadcrumb: TRAVEL_PRODUCT_TITLE,
      planTitle: TRAVEL_PRODUCT_TITLE,
      planSub: 'Select cover and dates — your premium updates live.',
      saleBreadcrumb: `${TRAVEL_PRODUCT_TITLE} / Complete sale`,
      saleTitle: 'Traveller details & payment',
      contactSection: 'Customer contact',
      contactHint: 'Mapfre sends the policy certificate to this email after issuance.',
      declaration: 'Customer confirms details are correct and agrees to Pacis data protection policy.',
      newSale: 'New Sale',
      newSaleSub: 'Unsaved details in this session will be removed. Existing saved quotes remain in the system.',
    },
    trackAnalytics: true,
    useAgentPayment: true,
    prefillContactFromProfile: false,
  };
}
